module.exports = "<div ng-if=\"generateReportCtrl.loaded\" bind-html-compile=\"generateReportCtrl.template\"></div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/generateReports/template.html
// module id = 1361
// module chunks = 0